import { BaseClient, IActionResponse, IActionResult, IPagedResult } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { GridPlanDto, GridSubscriptionPlanDto, PlanDto, SearchDto, SubscriptionPlanDto } from "../../dto";


export class PlanClient extends BaseClient {
  routes = ["admin", "Plan"];

  async getPlanAsync(id: string | undefined): Promise<PlanDto> {
    const actions: string[] = ["GetPlan"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];

    const result: PlanDto = await this.getAsync<PlanDto>(actions, params);
    return result;
  }

  async getPlansAsync(): Promise<PlanDto[]> {
    const actions: string[] = ["GetAllPlans"];

    const result: PlanDto[] = await this.getAsync<PlanDto[]>(actions);
    return result;
  }

  async searchPlansAsync(
    payload: SearchDto | undefined
  ): Promise<IPagedResult<GridPlanDto>> {
    const actions: string[] = ["SearchPlan"];
    const result: IPagedResult<GridPlanDto> = await this.postAsync<
      SearchDto,
      GridPlanDto,
      IPagedResult<GridPlanDto>
    >(actions, payload);
    return result;
  }

  async savePlanAsync(
    payload: PlanDto | undefined
  ): Promise<IActionResult<PlanDto>> {
    const actions: string[] = ["SavePlan"];
    return await this.postAsync<PlanDto>(actions, payload);
  }

  async deActivatePlanAsync(id: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["DeActivatePlan"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];
    return await this.getAsync(actions, params);
  }

  async saveSubscriptionPlanAsync(
    payload: SubscriptionPlanDto | undefined
  ): Promise<IActionResult<SubscriptionPlanDto>> {
    const actions: string[] = ["SaveSubscriptionPlan"];
    return await this.postAsync<SubscriptionPlanDto>(actions, payload);
  }

  async searchSubscriptionPlanAsync(
    payload: SearchDto | undefined
  ): Promise<IPagedResult<GridSubscriptionPlanDto>> {
    const actions: string[] = ["SearchSubscriptionPlan"];
    const result: IPagedResult<GridSubscriptionPlanDto> = await this.postAsync<
      SearchDto,
      GridSubscriptionPlanDto,
      IPagedResult<GridSubscriptionPlanDto>
    >(actions, payload);
    return result;
  }

  async deActivateSubscriptionPlanAsync(
    id: string | undefined
  ): Promise<IActionResponse> {
    const actions: string[] = ["DeActivateSubscriptionPlan"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];
    return await this.getAsync(actions, params);
  }
}
